import { useGetAccountsQuery } from "@/modules/account/services";
import type { IAccountTransferTemplateForm } from "@/modules/template/common/types";
import { AccountTransferTemplateForm } from "@/modules/template/components";
import { accountTransferTemplateValidationSchema } from "@/modules/template/validations";
import { INITIAL_PAGE_SIZE } from "@/shared/common/constants";
import type { IOperationPageProps } from "@/shared/common/types";
import { PageHeader } from "@/shared/components";
import { useTranslationExists } from "@/shared/hooks";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import { useState } from "react";

export const AccountTransferTemplate = ({ isEdit }: IOperationPageProps) => {
  const { t } = useTranslationExists();
  const [isAccountNumberInvalid, setIsAccountNumberInvalid] = useState<boolean>(false);
  const { data: accountsList = [] } = useGetAccountsQuery({
    pageSize: INITIAL_PAGE_SIZE,
  }, {
    refetchOnMountOrArgChange: true,
  });

  const initialValues: IAccountTransferTemplateForm = {
    creditAccount: "",
    debitAccount: "",
    beneficiary: "",
    name: "",
    amount: "",
    purpose: "",
    commissionAccount: "",
    beneficiaryLegalStatus: null,
  };

  return (
    <FormContainer
      className="full-width page-container form-layout"
      formId="form-container"
      mode="onBlur"
      reValidateMode="onBlur"
      initialValues={initialValues}
      validationScheme={accountTransferTemplateValidationSchema({ t, isAccountNumberInvalid })}
    >
      <PageHeader/>
      <AccountTransferTemplateForm
        isEdit={isEdit}
        accountsList={accountsList}
        setIsAccountNumberInvalid={setIsAccountNumberInvalid}
      />
    </FormContainer>
  );
};
